module.exports = __webpack_public_path__ + "img/top_logo.f4b7eaee.png";